/**
 * `useDiscardHeldResolve` — #2263, `POST /api/cycles/{id}/held-resolve:discard`.
 *
 * Drops a window's held re-solve (its drafts and its list of published seats
 * to replace) so the roster that is out stands and a cover the 409 refused can
 * go through. Lead only. 404 when nothing is held any more.
 *
 * Success (and a 404, which means the screen was stale) refreshes every read:
 * the discard changes the grid, the waiting count, the ladder's options and
 * the swap board at once, and it is a rare press.
 */
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { type ApiError, apiFetch } from "./client";
import type { components } from "./schema.gen";

export type HeldResolveDiscardResponse = components["schemas"]["HeldResolveDiscardResponse"];
export type HeldResolveWaiting = components["schemas"]["HeldResolveWaiting"];

export function useDiscardHeldResolve(cycleId: string) {
  const queryClient = useQueryClient();
  return useMutation<HeldResolveDiscardResponse, ApiError | Error, void>({
    mutationFn: () =>
      apiFetch<HeldResolveDiscardResponse>(
        `/api/cycles/${encodeURIComponent(cycleId)}/held-resolve:discard`,
        { method: "POST" },
      ),
    onSettled: () => queryClient.invalidateQueries(),
  });
}
